<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('resources.createReservation') }}</h1>
      <div class="form-container">
        <ReservationForm :reservationData="data" @save="save"></ReservationForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import IssueTrackerForm from '@/components/IssueTrackerForm'
  import ReservationForm from '@/components/ReservationForm'

  export default {
    components: {
      ReservationForm,
      DashboardLayout,
      IssueTrackerForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Resources/reserve', {
          resourceId: this.$route.params.resourceId,
          form
        }).then(() => {
          this.$router.push({ name: 'resources' })
        })
      }
    },
    computed: {
      data() {
        let date = new Date(parseInt(this.$route.params.date))
        return {
          starts_at: new Date(date.setHours(8,0,0,0)),
          ends_at: new Date(date.setHours(18,0,0,0))
        }
      },
      breadcrumbs() {
        return [
          {name: 'resources', path: 'resources'},
          {name: 'createReservation'}
        ]
      }
    }
  }
</script>
